import React from "react";
import PropTypes from "prop-types";
import {
  FacebookShareButton,
  VKShareButton,
  PinterestShareButton
} from "react-share";
import FacebookIcon from "../Icons/FacebookIcon";
import PinterestIcon from "../Icons/PinterestIcon";
import VKIcon from "../Icons/VKIcon";
import withErrorBoundary from "../../../decorators/withErrorBoundary";

import styles from "./social-links.module.scss";

function SocialLinks(props) {
  const {url, title, description, media} = props;
  return (
    <div className={styles.root}>
      <FacebookShareButton url={url} quote={description}>
        <FacebookIcon />
      </FacebookShareButton>
      <VKShareButton
        url={url}
        title={title}
        description={description}
        image={media}
      >
        <VKIcon />
      </VKShareButton>
      <PinterestShareButton url={url} description={description} media={media}>
        <PinterestIcon />
      </PinterestShareButton>
    </div>
  );
}

SocialLinks.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  media: PropTypes.string
};

export default withErrorBoundary(SocialLinks);
